import { $, $$ } from "@utils/dom";
import { on, off } from "@utils/listener";

class SiteFooter {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.navs = [ ...$$('.site-footer__nav', this.el) ].map(nav => {
      return {
        el: nav,
        btn: $('.site-footer__navToggler', nav),
      }
    });

    this._onNavBtnClick = this._onNavBtnClick.bind(this);
  }

  init() {
    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    this.el = null;
    this.emitter = null;
    this.navs = null;

    this._onNavBtnClick = null;
  }

  _bindEvents() {
    if( this.navs ) this.navs.forEach(({ btn }) => on(btn, 'click', this._onNavBtnClick));
  }
  _unbindEvents() {
    if( this.navs ) this.navs.forEach(({ btn }) => off(btn, 'click', this._onNavBtnClick));
  }
  
  _onNavBtnClick(event) {
    const { currentTarget } = event;

    // find nav related to this button
    const nav = this.navs.find(({ btn }) => btn === currentTarget);
    if( !nav ) return;

    nav.el.classList.toggle('--js-menu-open');
    this.emitter.emit('SiteScroll.update');
  }
}

export default SiteFooter;
